{
  "version": 1,
  "asset_id": "cb159335-dd03-4e61-9e99-27a9437e67c4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cb159335-dd03-4e61-9e99-27a9437e67c4/sleeve-ugi-reflux-post-800-es.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cb159335-dd03-4e61-9e99-27a9437e67c4/sleeve-ugi-reflux-post-800-es.webp",
  "original_filename": "sleeve-ugi-reflux-post-800-es.webp",
  "size": 47910,
  "content_type": "image/webp",
  "created_at": "2026-09-28T16:44:21Z"
}
